import tmpbunkers from "./bunkerparamsoutFeb2023.json"

export const Bunker =tmpbunkers
